if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

this.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-modal-thumbnail]');

  if (!thumbnail) return;

  event.preventDefault();

  const mediaId = thumbnail.getAttribute('data-media-id');

  if (mediaId) {
    this.showMedia(mediaId);
  }
});
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');

        if (mediaId) {
          this.showMedia(mediaId);
        }
      }

      showMedia(mediaId) {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        const container = this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        this.querySelectorAll('[data-modal-thumbnail]').forEach((thumbnail) => {
          const isActive = thumbnail.getAttribute('data-media-id') === mediaId;

          thumbnail.classList.toggle('active', isActive);
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}